module.exports = __webpack_public_path__ + "media/images/patent/x_9-fca9a8ecbda59ef87b56bb87af944683.png";